import NoMonetizationPage from './NoMonetizationPage';
import './assets/no-monetization.scss';

export default NoMonetizationPage;